module.exports = __webpack_public_path__ + "media/recipes/81-d729afbf.png";